import WithSidebar from "../../../layouts/WithSidebar"
import { useLocation } from "react-router-dom"
import LinkByPnrForm from "../../../components/Link-by-pnr"

const LinkByPnr = () => {
    const {state} = useLocation()
    
    return(
        <WithSidebar pageTitle={'Get Payment Detail By PNR'} breadcrumb={`Dashboard > Payment link > By PNR `}>
            <LinkByPnrForm paymentType={state.paymentType}/>
        </WithSidebar>
    )
}
export default LinkByPnr